module.exports = __webpack_public_path__ + "img/Numerai-Logo-Side-Black.8393ed16.png";